import { PreviewReadingPage } from './PreviewReadingPage'
import { withPreviewReadingPage } from './withPreviewReadingPage'

const ConnectedPreviewReadingPage = withPreviewReadingPage(PreviewReadingPage)

export { ConnectedPreviewReadingPage as PreviewReadingPage }
